var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    {
      staticClass: "table table--fixed v-table__header",
      class: { "v-table__border": _vm.border },
    },
    [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.columns, function (col, index) {
            return _c(
              "th",
              {
                key: index + 1,
                class: { "v-table__header--sort": col.isSort },
                attrs: { width: _vm.getColWidth(col.width), align: col.align },
                on: {
                  click: function ($event) {
                    return _vm.sortTable(col)
                  },
                },
              },
              [
                col.type === "selection"
                  ? _c("v-checkbox", {
                      staticClass: "v-table__header__checkbox",
                      attrs: {
                        "before-change": _vm.beforeSelectAll,
                        hasValue: _vm.hasValue,
                      },
                      model: {
                        value: _vm.checkboxValue,
                        callback: function ($$v) {
                          _vm.checkboxValue = $$v
                        },
                        expression: "checkboxValue",
                      },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "v-table__header__label" }, [
                  _vm._v(_vm._s(col.label)),
                ]),
                col.isSort
                  ? _c("span", { staticClass: "v-table__sort" }, [
                      _c("span", {
                        staticClass: "v-table__icon v-table__icon--up",
                        class: {
                          active:
                            col.sortType === "asc" && _vm.sortProp === col.prop,
                        },
                      }),
                      _c("span", {
                        staticClass: "v-table__icon v-table__icon--down",
                        class: {
                          active:
                            col.sortType === "desc" &&
                            _vm.sortProp === col.prop,
                        },
                      }),
                    ])
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }